import * as yup from 'yup';

export const useSchemaInvoiceGroup = () => {
  const invoiceGroupSchema = yup.object().shape({
    // Swish
    swishAccount: yup.string().optional(),
    swishData1: yup.string().optional(),
    swishActive: yup.string().oneOf(['0', '1']).optional(),

    // Stripe
    stripeAccount: yup.string().optional(),
    stripeActive: yup.string().oneOf(['0', '1']).optional(),

    // Bank
    accountNr: yup.string().optional(),
    accountType: yup.number().optional(),
    accountName: yup.string().optional(),
    iban: yup.string().optional(),
    bic: yup.string().optional(),

    // Autogiro
    autogiroCustomerNr: yup.string().optional(),
    autogiroAccount: yup.string().optional(),

    // Övriga betalmetodinställningar
    paymentMethod: yup.number().optional(),
    paymentMethodOrder: yup.string().optional(),
    pmSelectionHeader: yup.string().optional(),
    preSelect: yup.boolean().optional(),
    autoApprovePayments: yup.boolean().optional(),
    sharedAccount: yup.boolean().optional(),

    // Kortdata
    cardData1: yup.string().optional(),
    cardData2: yup.string().optional(),
    cardData3: yup.string().optional(),
    cardSupplier: yup.number().optional(),

    // Avgifter / avtal
    adminFee: yup.number().nullable().optional(),

    // Övriga metadata
    customerNr: yup.string().optional(),
    name: yup.string().optional(),
    owner_id: yup.number().optional(),
    localAssIds: yup.string().optional(),
    payerNumberIsBirthdate: yup.boolean().optional(),
    continueBtnText: yup.string().optional(),
    senderTitle: yup.string().optional(),
    template_id: yup.number().optional(),
    paymentMethods: yup.array().of(
      yup.object({
        paymentMethodId: yup.number().required(),
        pos: yup.number().required(),
        active: yup.mixed<'0' | '1'>().oneOf(['0', '1']).required(),
        preSelected: yup.mixed<'0' | '1'>().oneOf(['0', '1']).required(),
        name: yup.string().optional(),
      }),
    ),
  });

  return invoiceGroupSchema;
};
